export const projects = [
  {
    title: "My Portfolio Website",
    description:
      "A personal site showcasing your work and skills, built with React and Bootstrap for responsive design and smooth navigation.",
    image: "/images/portfolio.png",
    github: "https://github.com/yourusername/portfolio",
    demo: "https://nataliedambaza.dev/",
  },
  {
    title: "Weather App",
    description:
      "A live weather dashboard using React and OpenWeather API, displaying real-time data with dynamic UI updates.",
    image: "/images/weather-app.png",
    github: "https://github.com/Ndambaza/weather-app-react",
    demo: "https://sunny-entremet-a7f605.netlify.app/",
  },
  {
    title: "Dictionary App",
    description:
      "A simple word lookup tool built with React, integrating multiple dictionary APIs to fetch definitions and phonetics.",
    image: "/images/dictionary-app.png",
    github: "https://github.com/Ndambaza/dictionary-project",
    demo: "https://jovial-alpaca-03b119.netlify.app/",
  },

  {
    title: "K-Drama Landing Page Project",
    description:
      "A stylish landing page themed around Korean dramas, created with HTML, CSS, JavaScript, and Bootstrap for layout and styling.",
    image: "/images/k-drama.png",
    github: "https://github.com/Ndambaza/K-drama-Project",
    demo: "https://k-drama-project.netlify.app/",
  },

  {
    title: "Dream Travel Destitination Landing Page",
    description:
      "A clean, responsive travel-themed landing page using HTML, CSS, and JavaScript, designed to inspire wanderlust.",
    image: "/images/travel-landing.png",
    github: "https://github.com/Ndambaza/Travel-Landing",
    demo: "https://travel-bucket-list-challenge.netlify.app/",
  },
  {
    title: "My Portfolio Project",
    description:
      "An earlier portfolio version built with Bootstrap, showcasing your foundational front-end skills and layout design.",
    image: "/images/portfolio-project.png",
    github: "https://github.com/Ndambaza/Portfolio-Project",
    demo: "https://natalie-portfolio-project.netlify.app/",
  },

  {
    title: "World Clock Project",
    description:
      "A multi-timezone clock interface built with Bootstrap and JavaScript, displaying current times across global cities.",
    image: "/images/world-clock.png",
    github: "https://github.com/Ndambaza/world-clock",
    demo: "https://world-clock-nd-project.netlify.app/",
  },

  {
    title: "Love Poem Generator",
    description:
      "A playful app that generates random love poems using Bootstrap and JavaScript, combining creativity with code.",
    image: "/images/love-poem.png",
    github: "https://github.com/Ndambaza/love-poem-generator",
    demo: "https://love-poems-generator.netlify.app/",
  },
];
